// @flow
import type {
  Action,
} from 'fc-flow-types/redux'

import {
  ADD_ASSET,
  DELETE_ASSETS,
  EDIT_ASSETS,
  // UPLOAD_FIELD_BORDERS,
} from './constants'

import {
  updateFarm,
  updateField,
} from 'hfty-assets'

import { push } from 'react-router-redux'

export function addAsset (): Action<> {
  return {
    type: ADD_ASSET,
  }
}

export function editAssets (): Action<> {
  return {
    type: EDIT_ASSETS,
  }
}

export function deleteAssets (): Action<> {
  return {
    type: DELETE_ASSETS,
  }
}

export function zoomOnMap (dispatch: Dispatch<*>): Function {
  return function (asset: Object) {
    const cat = asset.category
    const id = asset.id

    if (cat === 'Field') {
      dispatch(updateFarm(asset.parentId))
      dispatch(updateField(id))
      dispatch(push('/map/assets'))
    } else {
      dispatch(updateFarm(id))
      dispatch(push('/map/assets'))
    }
  }
}
